module.exports = __webpack_public_path__ + "img/inactive_arrow_right.1cd417ed.svg";